import React, { useEffect, useRef } from 'react';
import ConfirmModal from '../shared/ConfirmModal';

/**
 * Το κοινό ConfirmModal, όταν ανοίγει πάνω από συρτάρι (DetailPanel): το focus μπαίνει στο «Άκυρο» του
 * παραθύρου — αλλιώς έμενε στο κουμπί του συρταριού και το Tab γύριζε μόνο μέσα στο συρτάρι — και το Esc
 * κλείνει την επιβεβαίωση (όχι το συρτάρι από κάτω).
 */
type ConfirmModalProps = React.ComponentProps<typeof ConfirmModal>;

export const OrgConfirm: React.FC<ConfirmModalProps> = props => {
  const { isOpen, onCancel } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    ref.current?.querySelector<HTMLButtonElement>('button')?.focus();
  }, [isOpen]);

  return (
    <div
      ref={ref}
      onKeyDown={e => {
        if (e.key !== 'Escape' || !isOpen) return;
        e.preventDefault();
        e.stopPropagation();
        onCancel();
      }}
    >
      <ConfirmModal {...props} />
    </div>
  );
};

export default OrgConfirm;
